import {config} from "../config/config";

export const ORGANIZATION = 'organization';
export const ENTITY_TAG = 'entityTag';
export const USER = 'user';
export const KEYCLOAK_SECURITY_GROUPS = config.KEYCLOAK_URL + 'auth/admin/realms/reveal/groups';
export const DOWNLOAD_USER_BULK_TEMPLATE = config.API_BASE_URL + '/user/bulk/csv';
export const DOWNLOAD_LOCATION_BULK_TEMPLATE = config.API_BASE_URL + '/location/bulk/sample';
export const GEOGRAPHIC_LEVEL = 'geographicLevel';
export const LOCATION_HIERARCHY = 'locationHierarchy';
export const GENERATED_LOCATION_HIERARCHY = 'genericHierarchy';
export const LOCATION = 'location';
export const PLAN = 'plan';
export const REPORTS = 'dashboard';
export const INSTANCE = 'instance';
// export const GROUP_MANAGEMENT = 'groupmanagement';
export const META_IMPORT_DATASET = 'metaImport/dataset';
export const LOCATION_HIERARCHY_BASE = 'locationHierarchy/base';
export const LOCATION_HIERARCHY_ACTIVATE = 'locationHierarchy/activate';
export const COMPLEX_TAG = 'instance/tags/complex';

